import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ROUTES } from "./routes.config";
import type { JSX } from "react";

interface PrivateRouteProps {
  children: JSX.Element;
  requiredPermissions?: string[];
}

const PrivateRoute = ({ children, requiredPermissions }: PrivateRouteProps) => {
  const location = useLocation();
  const { isAuthenticated, user, loading } = useAuth();
  // Show loading spinner while auth is being initialized
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  // Check if user is authenticated
  if (!isAuthenticated || !user) {
    // Redirect to login with return url
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  // Check for super admin access
  if (requiredPermissions?.includes("SUPER_ADMIN")) {
    if (user.role !== "SUPER_ADMIN") {
      // Redirect non-super-admin users to their appropriate dashboard
      return <Navigate to={ROUTES.HOME} replace />;
    }
  }

  // Check for admin access
  if (requiredPermissions?.includes("ADMIN")) {
    if (!["ADMIN", "SUPER_ADMIN"].includes(user.role)) {
      return <Navigate to={ROUTES.HOME} replace />;
    }
  }

  return children;
};

export default PrivateRoute;
